import React from 'react';
import Page from '@signal/layouts/Page';
import renderIf from '@signal/utils/renderIf';
import DesktopHeader from '../DesktopHeader';
import MultiAppMenuPanelSkeleton from '../MultiAppMenuPanel/Skeleton';
export default function CommonPageSkeleton(_ref) {
  var children = _ref.children,
      hideMenu = _ref.hideMenu,
      Skeleton = _ref.Skeleton;
  return /*#__PURE__*/React.createElement(Page, {
    constrainWidth: false,
    left: hideMenu ? undefined : MultiAppMenuPanelSkeleton
  }, /*#__PURE__*/React.createElement(DesktopHeader, {
    hideLogo: true,
    fullWidth: true
  }), renderIf(Boolean(Skeleton), Skeleton, children));
}